import React, { Component } from "react";
import { Button } from "react-bootstrap";
import uniqueId   from 'lodash/uniqueId';
import Sortable from 'react-sortablejs';
import groupBy  from 'lodash/groupBy';
import SortableDayViewExerciseList from "./SortableDayViewExerciseList";
import getMeasureTitle             from "../../utils/Measure";
import { ExerciseFreeFormId }   from "../../utils/StaticIds";

export default class SortableDayViewBlockList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            block_data: []
        }
    }

    componentDidMount() {
        //console.log("componentDidMount --------");
        //this.getExerciseOrder();
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            block_data: nextProps.block_data,
            ex_names: nextProps.ex_names
        })
    }

    getExerciseOrder() {
        var list = document.getElementsByClassName("trackBlockBox");
        var blocks_order_arr = [];
        var blocks_exercs_order_arr = [];
        var ff_exists;
        console.log("+++++++++++++  BEGIN get ExerciseOrder  +++++++++++++");
        var bangi_dude_test_arr = [];
        // Must get these: week id, day id, block id and exercise id
        for (var i = 0; i < list.length; i++) {
            var child_lgth = list[i].children.length;
            console.log("Get block info...");
            for (var j = 0; j < child_lgth; j++) {
                var tmp_block_id = list[i].children[j].attributes.getNamedItem("block_id").value;

                blocks_order_arr.push(tmp_block_id);

                var exerc_lgth = list[i].children[j].children[1].children.length;
                var exercise_order_arr = [];
                console.log("*** Block id: " + tmp_block_id);
                var tmp_ff_arr = [];
                console.log("Loop through exercises...");
                for (var k = 0; k < exerc_lgth; k++) {
                    var tmp_exercise_name = list[i].children[j].children[1].children[k].attributes.getNamedItem("ex_name").value;
                    var tmp_exercise_id   = list[i].children[j].children[1].children[k].attributes.getNamedItem("ex_id").value;
                    var tmp_set_id        = list[i].children[j].children[1].children[k].attributes.getNamedItem("set_id").value;
                    console.log("Exercise name: " + tmp_exercise_name);
                    exercise_order_arr.push(tmp_set_id);

                    // check if free-form exists in array //
                    tmp_ff_arr.push(tmp_exercise_id);
                    bangi_dude_test_arr.push([tmp_block_id, tmp_set_id, tmp_exercise_id])
                }

                // Conditional: Check if Free-Form exerc exists in array //
                // If FF exists, reset DOM tree and do not allow drag n' drop
                if(tmp_ff_arr.length > 1) {
                    var contains_ff = tmp_ff_arr.indexOf(ExerciseFreeFormId);
                    if(contains_ff != -1) ff_exists = true;
                }

                blocks_exercs_order_arr.push([tmp_block_id, exercise_order_arr])
            }
        }
        //console.log(" ");
        //console.log("bangi_dude_test_arr [0]: " + bangi_dude_test_arr[0]);
        //console.log("bangi_dude_test_arr full: " + JSON.stringify(bangi_dude_test_arr));
        //if(block_id != null && !ff_exists) {
        if(!ff_exists) {
            console.log("--------------------------------------------------");
            console.log("blocks_order_arr: " + blocks_order_arr);
            console.log("blocks_exercs_order_arr: " + blocks_exercs_order_arr);
            console.log("exercise_order_arr: " + exercise_order_arr);
            //this.props.sortBlocksOnDayView(blocks_exercs_order_arr, blocks_order_arr, exercise_order_arr, day_id);
        }
        console.log("+++++++++++++  END get ExerciseOrder  +++++++++++++");
    }

    renderBlock(name, index, week_id, day_id, block_id, value, addExerciseRow, showExerciseDetailRow ){

        var block_name = "Block " + (parseInt(index)+1);

        if(name != null && name != "") block_name = name;

        /***** BEGIN Hide '+ Add Exercise' footer if it's a Free-Form block *****/
        var exercise_obj = value.exercise;

        for(var key in exercise_obj) {
            var exercise_row = Object.keys(exercise_obj).map( index => {
                    var exercise_id     = exercise_obj[index].id;
                    if(exercise_id === ExerciseFreeFormId) addExerciseRow = "";
            });
        }
        /***** END: Hide '+ Add Exercise' footer if it's a Free-Form block *****/

        return <div key={uniqueId()}
                    data-id  = {block_id}
                    week_id  = {week_id}
                    block_id = {block_id}
                    block_name = {block_name}
                    className = {"entireBlockContainer"}
                    style={{padding:"0" }}>

                                <div className="blockContainer tile__name"
                                         week_id  = {week_id}
                                         block_id = {block_id}
                                         >
                                    <span className="blockTitle"
                                          style={{cursor:"pointer", width:"69%", zIndex:100}}
                                          onClick={() => this.props.handleChangeBlockName(block_id, index, name)}
                                    >
                                         { block_name /*block_id*/ }
                                    </span>
                                    <span className="btnBlockRow">
                                        <span className="btnInnerBlockRow">
                                            <Button onClick={() => this.props.handleSaveBlock(block_id, name)}
                                                    className="glyphicon glyphicon-save adjustBlockSaveBtn darkGrayBtnView">
                                            </Button>
                                             &nbsp;&nbsp;

                                            <Button onClick={() => this.props.handleDuplicateBlock(index)}
                                                    className="glyphicon glyphicon-duplicate adjustBlockDuplicateBtn darkGrayBtnView">
                                            </Button>
                                             &nbsp;&nbsp;

                                            <Button id      = {index}
                                                    onClick = {() => this.props.handleDeleteBlock(index)}
                                                    className = "glyphicon glyphicon-remove adjustBlockDeleteBtn darkGrayBtnView">

                                            </Button>
                                        </span>
                                    </span>
                                </div>

                                        <Sortable
                                            className="trackExerciseBox"
                                            options={{
                                                group: "exercises",
                                                sort: true,
                                                animation: 150,
                                                // not useable: onStart: (evt) => { },
                                                onEnd: (evt) => {
                                                    //console.log("+++++++++++++++   ON DAY VIEW END   ++++++++++++++++");
                                                    var itemEl = evt.item;   // dragged HTMLElement
                                                    //var evt_to = evt.to.children;     // not useable
                                                    //var evt_from = evt.from.children; // not useable
                                                    // gives incorrect values (don't use): var evt_old_index = evt.oldIndex;  // element's old index within old parent
                                                    // gives incorrect values (don't use): var evt_new_index = evt.newIndex;  // element's new index within new parent

                                                    var is_free_form_id = itemEl.attributes.getNamedItem("ex_id").value;
                                                    var dont_move_exerc = true;
                                                    var ff_exists       = false;

                                                    if(ExerciseFreeFormId != is_free_form_id) {
                                                            var list = document.getElementsByClassName("trackBlockBox");
                                                            var blocks_order_arr = [];
                                                            var blocks_exercs_order_arr = [];

                                                            for (var i = 0; i < list.length; i++) {
                                                                var child_lgth = list[i].children.length;
                                                                // get ids for entire day: console.log("Get block info...");
                                                                for (var j = 0; j < child_lgth; j++) {
                                                                    var tmp_block_id = list[i].children[j].attributes.getNamedItem("block_id").value;

                                                                    blocks_order_arr.push(tmp_block_id);

                                                                    var exerc_lgth = list[i].children[j].children[1].children.length;
                                                                    var exercise_order_arr = [];
                                                                    // get ids for entire day: console.log("*** Block id: " + tmp_block_id);
                                                                    var tmp_ff_arr = [];
                                                                    // get ids for entire day: console.log("Loop through exercises...");
                                                                    for (var k = 0; k < exerc_lgth; k++) {
                                                                        var tmp_exercise_name = list[i].children[j].children[1].children[k].attributes.getNamedItem("ex_name").value;
                                                                        var tmp_exercise_id   = list[i].children[j].children[1].children[k].attributes.getNamedItem("ex_id").value;
                                                                        var tmp_set_id        = list[i].children[j].children[1].children[k].attributes.getNamedItem("set_id").value;
                                                                        // get ids for entire day: console.log("Exercise name: " + tmp_exercise_name);
                                                                        exercise_order_arr.push(tmp_set_id);

                                                                        // check if free-form exists in array //
                                                                        tmp_ff_arr.push(tmp_exercise_id);
                                                                    }

                                                                    // Conditional: Check if Free-Form exerc exists in array //
                                                                    // If FF exists, reset DOM tree and do not allow drag n' drop
                                                                    if(tmp_ff_arr.length > 1) {
                                                                        var contains_ff = tmp_ff_arr.indexOf(ExerciseFreeFormId);
                                                                        if(contains_ff != -1) ff_exists = true;
                                                                    }

                                                                    blocks_exercs_order_arr.push([tmp_block_id, exercise_order_arr])
                                                                }
                                                            }

                                                            if(block_id != null && !ff_exists) {
                                                                /*
                                                                // get ids for entire day: console.log("-------------------------");
                                                                console.log("blocks_order_arr: " + blocks_order_arr);
                                                                console.log("blocks_exercs_order_arr: " + blocks_exercs_order_arr);
                                                                console.log("exercise_order_arr: " + exercise_order_arr);
                                                                */
                                                                this.props.sortBlocksOnDayView(blocks_exercs_order_arr, blocks_order_arr, exercise_order_arr, day_id);
                                                            } else {
                                                                this.props.getProgramDOMTree(dont_move_exerc,2); // reset the moved exercise in the dom tree
                                                            }
                                                    } else {
                                                        this.props.getProgramDOMTree(dont_move_exerc, 3); // reset the moved exercise in the dom tree
                                                    }
                                                },
                                            }}
                                        >
                                                <SortableDayViewExerciseList
                                                    index                 = {index}
                                                    block_index           = {index}
                                                    block_name            = {block_name}
                                                    week_id               = {week_id}
                                                    day_id                = {day_id}
                                                    block_id              = {block_id}
                                                    exercise              = {value.exercise}
                                                    showDayModalSimple    = {this.props.showDayModalSimple}
                                                    handleDeleteExercise  = {this.props.handleDeleteExercise}
                                                    exerciseIdsWithNotes  = {this.props.exerciseIdsWithNotes}
                                                    showExerciseDetailRow = {showExerciseDetailRow}
                                                />

                                        </Sortable>

                                { addExerciseRow }
                </div>
    }

    render() {

        var name           = this.props.name;
        var index          = this.props.index;
        var week_id        = this.props.week_id;
        var day_id         = this.props.day_id;
        var block_id       = this.props.block_id;
        var block_ids      = this.props.block_ids;
        var block_order    = this.props.block_order;
        var value          = this.props.value; // value.exercise used in modal simple
        var addExerciseRow = this.props.addExerciseRow;
        var showExerciseDetailRow = this.props.showExerciseDetailRow;
        var block = null;
        var sortableBlock;

        if(block_id != "" && block_id != undefined) {

                sortableBlock = <Sortable
                                    className="trackBlockBox"
                                    // Sortable React Component: https://github.com/cheton/react-sortable
                                    // Sortable Core Options: https://github.com/RubaXa/Sortable#options

                                    options = {{
                                        group: "blocks",
                                        sort: true,
                                        animation: 150,
                                        // not useable: onStart: (evt) => { },
                                        onEnd: (evt) => {
                                            var itemEl = evt.item;   // dragged HTMLElement
                                            //var evt_to = evt.to;     // not useable
                                            //var evt_from = evt.from; // not useable
                                            // gives incorrect values (don't use): var evt_old_index = evt.oldIndex;  // element's old index within old parent
                                            // gives incorrect values (don't use):var evt_new_index = evt.newIndex;  // element's new index within new parent

                                            var list = document.getElementsByClassName("trackBlockBox");
                                            var blocks_order_arr        = [];
                                            var blocks_exercs_order_arr = [];

                                            for (var i = 0; i < list.length; i++) {
                                                var child_lgth = list[i].children.length;

                                                for (var j = 0; j < child_lgth; j++) {
                                                    var tmp_block_id = list[i].children[j].attributes.getNamedItem("block_id").value;
                                                    blocks_order_arr.push(tmp_block_id);

                                                    var exerc_lgth = list[i].children[j].children[1].children.length;
                                                    var exercise_order_arr      = []; // reset array
                                                    for (var k = 0; k < exerc_lgth; k++) {
                                                        var tmp_set_id = list[i].children[j].children[1].children[k].attributes.getNamedItem("set_id").value;
                                                        exercise_order_arr.push(tmp_set_id);
                                                    }

                                                    blocks_exercs_order_arr.push([tmp_block_id, exercise_order_arr])
                                                }
                                            }

                                            if(block_id != null)
                                                this.props.sortBlocksOnDayView(blocks_exercs_order_arr, blocks_order_arr, exercise_order_arr, day_id);

                                        },
                                    }}
                                >

                                        { this.renderBlock(name, index, week_id, day_id, block_id, value, addExerciseRow, showExerciseDetailRow ) }
                            </Sortable>
            }

        { value ? block =  sortableBlock : null }

        return block;
    }
};

/*Sortable.propTypes = {
    items: React.PropTypes.array,
    onChange: React.PropTypes.func
};*/



// WEBPACK FOOTER //
// ./src/components/sortable/SortableDayViewBlockList.js